export default __webpack_public_path__ + "static/media/Toiture_avant.f640acc7.png";